export const ACTIVITY_TYPE_LABELS = {
	driving: 'Driving',
	hosting: 'Hosting',
	resting: 'Resting',
	signOn: 'Sign On',
	signOff: 'Sign Off',
	fuelling: 'Fuelling',
	cleaning: 'Cleaning',
	garaging: 'Garaging',
	lapseTime: 'Lapse Time',
	deadhead: 'Deadhead',
	traveling: 'Traveling',
	protection: 'Protection',
};
